import React from "react";

const ProfileImage = ({
  widthMd,
  heightMd,
  widthSm,
  heightSm,
  leadingMd,
  leadingSm,
  profile_image,
  store_name,
}) => {
  return (
    <div
      className={`${widthSm} ${heightSm} ${widthMd} ${heightMd} ${
        profile_image === null ? "bg-black" : "bg-none"
      } rounded-full block`}
    >
      {profile_image === null ? (
        <p
          className={`text-white text-center text-3xl ${leadingSm} ${leadingMd}`}
        >
          {`${store_name.substring(0, 1).toUpperCase()}T`}
        </p>
      ) : (
        <img src={profile_image} alt="user profile" className="w-full h-full rounded-full object-cover" />
      )}
    </div>
  );
};

export default ProfileImage;
